import { Injectable } from '@angular/core'
import { Action, Store } from '@ngrx/store'
import * as AuthSelectors from './auth.selectors'
import { GbBaseFacade } from 'libs/shared/data-access-core/src/lib/+state/gb-base-facade-interface'
import { AuthenticationState } from './auth.reducer'

@Injectable({
  providedIn: 'root',
})
export class AuthFacade implements GbBaseFacade {
  isAuthenticated$ = this.store.select(AuthSelectors.selectIsAuthenticated)
  authProfile$ = this.store.select(AuthSelectors.selectAuthProfile)
  authUserProfile$ = this.store.select(AuthSelectors.selectAuthUserProfile)
  passwordRequired$ = this.store.select(AuthSelectors.selectPasswordRequired)
  authProfileId$ = this.store.select(AuthSelectors.selectAuthProfileId)
  token$ = this.store.select(AuthSelectors.selectAuthToken)
  authentication$ = this.store.select(AuthSelectors.selectAuthentication)
  type$ = this.store.select(AuthSelectors.selectAuthType)
  isVerificationEnabled$ = this.store.select(AuthSelectors.selectIsVerficationEnabled)
  isVolunteer$ = this.store.select(AuthSelectors.selectIsVolunteer)
  isGuest$ = this.store.select(AuthSelectors.selectIsGuest)
  authVerifyError$ = this.store.select(AuthSelectors.selectAuthVerifyError)
  hasVouchers$ = this.store.select(AuthSelectors.selectHasVouchers)
  hasFavouriteItems$ = this.store.select(AuthSelectors.selectHasFavouriteItems)
  getIsItemFavourited$ = (uuid: string) => this.store.select(AuthSelectors.getIsItemFavourited(uuid))

  constructor(private store: Store<AuthenticationState>) {}

  dispatch(action: Action): void {
    this.store.dispatch(action)
  }
}
